import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetYoutubeDetail = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/youtube/${idx}/detail`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "youtube_idx") setAlert("유튜브 idx를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) {
                    setAlert("유튜브 데이터가 존재하지 않습니다.")
                    navigate("/youtube")
                }
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetYoutubeDetail